import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend,
} from 'recharts';

import PanelCard from '../../performance-operations/components/PanelCard';
import { Sub, Table } from '../../performance-operations/styles';
import { monthlyRows } from '../config';

// Analiz §16 E13 orta sol — aylık geri bildirim, takdir, talep ve kontrol görüşmesi çizgisi; kapsam döneminin başlangıç/bitişi
// sabittir (seçili aralık). 1:1 çizgileri yalnız kiracı ayarı açıkken. Grafik + "Tablo Olarak Göster".
export default function MonthlyPanel({ panel }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [table, setTable] = useState(false);
  const d = panel.data;
  const rows = monthlyRows(d);
  const oneOnOne = !!d?.oneOnOneEnabled;
  const series = [
    { key: 'feedback', color: theme.colors.primary.main },
    { key: 'recognition', color: theme.colors.secondary.main },
    { key: 'requests', color: theme.colors.auxiliar.purple },
    ...(oneOnOne ? [
      { key: 'oneOnOneCompleted', color: theme.colors.secondary.dark },
      { key: 'oneOnOneDue', color: theme.colors.auxiliar.warning, dashed: true },
    ] : []),
  ];
  const suppressed = !!d?.suppressionReason;
  return (
    <PanelCard
      panelKey="monthly" title={t('performance.feedbackAnalytics.panel.monthly')} span={7}
      loading={panel.loading} error={panel.error} onRetry={panel.retry} empty={!suppressed && rows.length === 0}
      tableToggle={!suppressed} showTable={table} onToggleTable={() => setTable((v) => !v)}
    >
      {suppressed ? <Sub data-state="suppressed">{t('performance.feedbackAnalytics.suppressedNote')}</Sub> : null}
      {!suppressed && table ? (
        <Table>
          <thead>
            <tr>
              <th>{t('performance.feedbackAnalytics.col.month')}</th>
              {series.map((s) => <th key={s.key}>{t(`performance.feedbackAnalytics.series.${s.key}`)}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.key} data-row={r.key}>
                <td>{r.month}</td>
                {series.map((s) => <td key={s.key}>{r[s.key] ?? '-'}</td>)}
              </tr>
            ))}
          </tbody>
        </Table>
      ) : null}
      {!suppressed && !table ? (
        <div style={{ width: '100%', height: 240 }}>
          <ResponsiveContainer>
            <LineChart data={rows} margin={{ top: 8, right: 8, left: 0, bottom: 4 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="month" tick={{ fontSize: theme.metrics.font.size.xs }} interval="preserveStartEnd" />
              <YAxis allowDecimals={false} tick={{ fontSize: theme.metrics.font.size.xs }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: theme.metrics.font.size.xs }} />
              {series.map((s) => (
                <Line key={s.key} type="monotone" dataKey={s.key} name={t(`performance.feedbackAnalytics.series.${s.key}`)}
                  stroke={s.color} strokeWidth={2} strokeDasharray={s.dashed ? '4 3' : undefined} />
              ))}
            </LineChart>
          </ResponsiveContainer>
        </div>
      ) : null}
      {d?.truncated ? <Sub>{t('performance.feedbackAnalytics.monthsTruncated')}</Sub> : null}
      {!oneOnOne && !suppressed ? <Sub>{t('performance.feedbackAnalytics.oneOnOneOff')}</Sub> : null}
    </PanelCard>
  );
}
